import React from "react";
import { Helmet } from "react-helmet-async";
import { HeroCarousel } from "@/components/home/HeroCarousel";
import { StatsSection } from "@/components/home/StatsSection";
import { ProductsGrid } from "@/components/home/ProductsGrid";
import { WhyChoose } from "@/components/home/WhyChoose";
import { IndustriesSection } from "@/components/home/IndustriesSection";
import { ReviewsSection } from "@/components/home/ReviewsSection";
import { CTABanner } from "@/components/home/CTABanner";
import { COMPANY } from "@/data/company";

export default function Home({ onOpenEnquiry }) {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: COMPANY.name,
    description: COMPANY.description,
    address: {
      "@type": "PostalAddress",
      streetAddress: `${COMPANY.address.line1}, ${COMPANY.address.line2}`,
      addressLocality: COMPANY.address.city,
      addressRegion: COMPANY.address.state,
      postalCode: COMPANY.address.zip,
      addressCountry: COMPANY.address.country,
    },
    telephone: COMPANY.phone,
    email: COMPANY.email,
  };

  return (
    <>
      <Helmet>
        <title>
          Vortex Power Solutions | Servo Stabilizers & Isolation Transformers Manufacturer
        </title>
        <meta
          name="description"
          content="ISO & CE Certified manufacturer of Servo Voltage Stabilizers, Isolation Transformers, APSC, APC and Voltage Stabilizers. Based in Chennai, India — nationwide delivery."
        />
        <link rel="canonical" href="https://vortexpowersolutions.in/" />
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      </Helmet>
      <HeroCarousel onOpenEnquiry={onOpenEnquiry} />
      <StatsSection />
      <ProductsGrid />
      <WhyChoose />
      <IndustriesSection />
      <ReviewsSection />
      <CTABanner onOpenEnquiry={onOpenEnquiry} />
    </>
  );
}
